import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Utensils, Scissors, Sparkles, ShoppingBag, Dumbbell, Calendar } from "lucide-react";

export default function TrustedBy() {
	const { t } = useTranslation();

	const sectors = [
		{ icon: <Utensils className="w-5 h-5" />, name: t("trustedBy.sectors.restaurants") },
		{ icon: <Scissors className="w-5 h-5" />, name: t("trustedBy.sectors.barbers") },
		{ icon: <Sparkles className="w-5 h-5" />, name: t("trustedBy.sectors.beauty") },
		{ icon: <ShoppingBag className="w-5 h-5" />, name: t("trustedBy.sectors.shops") },
		{ icon: <Dumbbell className="w-5 h-5" />, name: t("trustedBy.sectors.trainers") },
		{ icon: <Calendar className="w-5 h-5" />, name: t("trustedBy.sectors.classes") },
	];

	return (
		<section className="py-12 bg-white border-y border-gray-100">
			<div className="max-w-6xl mx-auto px-6">
				<motion.p
					className="text-center text-sm text-gray-500 mb-6 font-medium uppercase tracking-wide"
					initial={{ opacity: 0, y: 10 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.5 }}
					viewport={{ once: true }}
				>
					{t("trustedBy.title")}
				</motion.p>

				<motion.div
					className="flex flex-wrap justify-center items-center gap-6 md:gap-10"
					initial={{ opacity: 0, y: 15 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.6, delay: 0.1 }}
					viewport={{ once: true }}
				>
					{sectors.map((sector, index) => (
						<motion.div
							key={sector.name}
							className="flex items-center gap-2 text-gray-400 hover:text-primary transition-colors duration-300"
							initial={{ opacity: 0, y: 10 }}
							whileInView={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.4, delay: index * 0.1 }}
							viewport={{ once: true }}
						>
							{sector.icon}
							<span className="text-sm font-medium">{sector.name}</span>
						</motion.div>
					))}
				</motion.div>
			</div>
		</section>
	);
}
